"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on 28.05.2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * PlacementTypesConverter.
 *
 * @author ZSr
 */


var PlacementTypesConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PlacementTypesConverter, _DataObjectConverter_);

  function PlacementTypesConverter() {
    _classCallCheck(this, PlacementTypesConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PlacementTypesConverter).apply(this, arguments));
  }

  return PlacementTypesConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PlacementTypesConverter = PlacementTypesConverter;